/*
 * @Descripttion: 关怀任务列表页
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, Table, Switch, Balloon, Dialog } from '@alifd/next';
import { history } from 'ice';
import moment from "moment";
import LzPagination from '@/components/common/LzPagination';
import OrderCareTaskSendListDetail from "@/components/SMS/OrderCareTaskSendListDetail/index";
import DdcfSummary from "../ddcfSummary";
import YscfSummary from "../yscfSummary";
import DdcpSummary from "../ddcpSummary";
import { Servlets } from '@/service';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';
import LzMsg from '@/components/common/LzMsg';
import PageUtils from '../../utils';
import style from './index.module.scss';

const TYPELIST = Object.keys(PageUtils.taskType).map(key => {
  return {
    label: PageUtils.taskType[key].label,
    value: PageUtils.taskType[key].realKey,
  }
}
);

const BASEFORMDATA = {
  taskName: '',
  taskType: '',
  taskPriority: '',
  taskActive: ''
};

const TaskList = () => {
  const [formSelect, setFormSelect] = useState({ ...BASEFORMDATA });
  const [tableLoading, setTableLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据
  const [tableData, setTableData] = useState([]);
  const [sendVisible, setSendVisible] = useState(false); // 发送记录弹窗
  const [sendId, setSendId] = useState(''); // 发送记录弹窗id

  const [summaryVisible, setSummaryVisible] = useState(false); // 效果数据弹窗
  const [summaryData, setSummaryData] = useState({}); // 效果数据弹窗数据

  const searchData = async (p) => {
    setTableLoading(true);
    await Servlets('getOrderCareList', {
      ...formSelect,
      ...pageInfo,
      ...p
    }).then((res) => {
      setTableLoading(false);// 关闭loading

      if (!res.success) {
        return;
      }

      setTableData(res.data ?? []); // 获取列表数据
      setPageInfo({
        ...pageInfo,
        ...res.page,
      })
    })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);/** 关闭loading */
      });
  };

  const handlePageSizeChange = async (pages: object = {}) => {
    try {
      await searchData({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      // LzMsg.error(e.message);
      console.log(e)
    }
  };

  // 开启关闭任务 type=1可以操作，0不可
  const switchDiv = (record, type = 1) => {
    return <Switch
      checked={record.taskActive ? true : false}
      disabled={type === 0}
      onClick={async () => {
        setTableLoading(true);
        // 修改taskActive布尔值
        await Servlets('activeOrderCareList', {
          active: Math.abs(record.taskActive - 1),
          taskId: record.id,
        }).then(async res => {
          if(res.success) {
            await searchData();
          } else {
            LzMsg.error(res.resp_msg);
            setTableLoading(false);/** 关闭loading */
          }
        })
        .catch((err) => {
          console.log(err);
          setTableLoading(false);/** 关闭loading */
        });
      }}
    />
  }

  // 表格里的状态栏
  const status = (value, index, record) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {
          record.taskTimeType === 2 && record.endTime < moment().valueOf() ? <Balloon.Tooltip
            align="t"
            trigger={
              switchDiv({ ...record }, 0)
            }
          >
            该任务已到达结束时间，无法重新启用；若想继续使用，可使用复制操作创建新的活动任务
          </Balloon.Tooltip>
            : switchDiv({ ...record }, 1)
        }
        {
          record.taskActive
            ?
            <span style={{ lineHeight: '30px', paddingLeft: '10px', height: '30px' }}>已开启</span>
            :
            <span style={{ lineHeight: '30px', paddingLeft: '10px', height: '30px' }}>已关闭</span>
        }
      </div>
    );
  };

  // 删除任务
  // 删除id
  const [deleteId, setDeleteId] = useState();
  // 确认删除dialog
  const [deleteMission, setDeleteMission] = useState(false);

  // 删除列表数据
  const deletePayList = async (id) => {
    setTableLoading(true);
    await Servlets('deleteOrderCareList', { taskId: id }).then(async (res) => {
      await searchData();
    })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);/** 关闭loading */
      });
  };

  const jumpUrl = (record, type) => {
    history.push(`./care/${type}/${record.taskType}/${record.id}`)
  };

  useEffect(() => {
    searchData();
  }, []);
  return <div className={style['order-care-task-list-container']}>
    <div className={style['list-search']}>
      <Form
        inline
        className={`${style['list-search-form']}`}
        size="medium"
      >
        <Form.Item label="任务名称：" className={style['form-item']}>
          <Input className={style['form-item-width']} value={formSelect.taskName} onChange={(e) => setFormSelect({ ...formSelect, taskName: e })} />
        </Form.Item>
        <Form.Item label="任务类型：" className={style['form-item']}>
          <Select className={style['form-item-width']} dataSource={TYPELIST} value={formSelect.taskType} onChange={(e) => setFormSelect({ ...formSelect, taskType: e })} />
        </Form.Item>
        <Form.Item label="优 先 级：" className={style['form-item']}>
          <Input className={style['form-item-width']} value={formSelect.taskPriority} onChange={(e) => setFormSelect({ ...formSelect, taskPriority: e })} />
        </Form.Item>
        <Form.Item label="任务状态：" className={style['form-item']}>
          <Select className={style['form-item-width']} dataSource={PageUtils.taskStatus} value={formSelect.taskActive} onChange={(e) => setFormSelect({ ...formSelect, taskActive: e })} />
        </Form.Item>
        <Form.Item label=" ">
          <div style={{ display: 'flex' }}>
            <Button style={{ marginRight: 10 }} type="primary" onClick={() => searchData({pageNo: 1})}>查询</Button>
            <Button onClick={() => {
              setFormSelect({ ...BASEFORMDATA });
              searchData({pageNo: 1, ...BASEFORMDATA});
            }}>重置</Button>
          </div>
        </Form.Item>
      </Form>
    </div>
    <Table dataSource={tableData} loading={tableLoading}>
      <Table.Column title="任务名称" dataIndex="taskName" />
      <Table.Column title="短信内容" dataIndex="smsContent" />
      <Table.Column title="任务类型" dataIndex="taskType" cell={(value, index, record) =>
          <div>{TYPELIST.find(item => {return item?.value == record.taskType})?.label ?? '--'}</div>
        }  width="100px"/>
      <Table.Column title="任务时效" cell={(value, index, record) => {
          return <div>
            {
              record.taskTimeType === 1 ? <div>不限制</div>
              : <div>
                  <div>开始时间：{moment(record?.startTime).format('YYYY-MM-DD HH:mm:ss')}</div>
                  <div>结束时间：{moment(record?.endTime).format('YYYY-MM-DD HH:mm:ss')}</div>
              </div>
            }

          </div>
        }}  width="215px"/>
      <Table.Column title="优先级" dataIndex="taskPriority" width="80px" />
      <Table.Column title="任务状态" dataIndex="taskActive" cell={status} width="150px" />
      <Table.Column title="操作"
        width="200px"
        cell={(value, index, record) => {
          return <div>
            <Button
              type="primary"
              text
              onClick={() => jumpUrl(record, 'view')}
            >查看
            </Button>
            <Button
              type="primary"
              text
              onClick={() => jumpUrl(record, 'edit')}
              style={{ marginLeft: '10px' }}
            >复制
            </Button>
            <Button
              type="primary"
              text
              onClick={() => { setSendId(record.id); setSendVisible(true) }}
              style={{ marginLeft: '10px' }}
            >发送记录
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: '10px' }}
              text
              disabled={record.taskActive == 1}
              onClick={() => {
                setDeleteMission(true), setDeleteId(record.id);
              }}
            >删除
            </Button>

            {
              ['S_DDCF', 'S_YSCF', 'S_DDCP'].indexOf(record.taskType) > -1 && <Button
                type="primary"
                text
                onClick={() => {
                  setSummaryData({...record});
                  setSummaryVisible(true);
                }}
              >营销效果
              </Button>
            }
          </div>
        }}
      />
    </Table>
    <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />

    <Dialog title="发送记录" onClose={()=>{setSendId(''); setSendVisible(false)}} visible={sendVisible} footer={false}>
      <OrderCareTaskSendListDetail id={sendId}/>
    </Dialog>

    <Dialog title="效果数据" onClose={()=>{setSummaryData({}); setSummaryVisible(false)}} visible={summaryVisible} footer={false}>
      {
        summaryData?.taskType === 'S_DDCF' && <DdcfSummary form={{...summaryData, taskId: summaryData?.id}} ref={null} />
      }
      {
        summaryData?.taskType === 'S_YSCF' && <DdcfSummary form={{taskId: summaryData?.id}} ref={null} />
      }
      {
        summaryData?.taskType === 'S_DDCP' && <DdcfSummary form={{taskId: summaryData?.id}} ref={null} />
      }
    </Dialog>

      {/* 删除任务dialog */}
      { deleteMission &&
        <ConfirmDialog
          promptInfo='是否确认删除'
          title="提示"
          flag={deleteMission}
          confirmHandel={() => {
            setDeleteMission(false);
            deletePayList(deleteId);
          }}
          cancelHandel={() => {
            setDeleteMission(false);
          }}
        />
      }
  </div>
};

export default TaskList;
